import React, { useRef, useState } from 'react';
import { Button, Form, Image } from 'react-bootstrap';
import LoadingComponent from '../LoadingComponent';
import config from '../../Api/config';
import { useDoctorIdUploadMutation } from './doctorApi';
import Swal from 'sweetalert2';

const DoctorIdImage = ({ email, image }) => {
    const fileInputRef = useRef(null);
    const [preview, setPreview] = useState(
        image ? `${config.API_URL}/${image}` : null
    );
    const [loading, setLoading] = useState(false);
    const [doctorIdUpload] = useDoctorIdUploadMutation();

    const handleButtonClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = async (event) => {
        if (!event.target.files[0]) return;

        setLoading(true);
        const previewUrl = URL.createObjectURL(event.target.files[0]);
        setPreview(previewUrl);

        let formData = new FormData();
        formData.append('UserEmail', email);
        formData.append('SignatureImage', event.target.files[0]); // Changed to DoctorIdImage to match purpose

        try {
            const { data } = await doctorIdUpload(formData);
            if (data) {
                Swal.fire({
                    title: 'Succès!',
                    text: 'ID médecin téléchargé avec succès',
                    icon: 'success',
                    confirmButtonText: 'OK',
                    timer: 3000,
                    timerProgressBar: true,
                    showClass: {
                        popup: 'animate__animated animate__fadeInDown',
                    },
                    hideClass: {
                        popup: 'animate__animated animate__fadeOutUp',
                    },
                });
            }
        } catch (error) {
            console.error('Upload failed:', error);
            Swal.fire({
                title: 'Erreur!',
                text: "Échec du téléchargement de l'ID médecin",
                icon: 'error',
                confirmButtonText: 'OK',
                showClass: {
                    popup: 'animate__animated animate__headShake',
                },
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            {loading && <LoadingComponent />}

            <Image
                src={preview}
                rounded
                className="mb-3"
                style={{ maxHeight: '200px' }}
            />
            <Button
                variant="primary"
                className="mt-3"
                onClick={handleButtonClick}
            >
                Télécharger l'ID du médecin
            </Button>
            <Form.Control
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: 'none' }}
                accept="image/*,.pdf,.doc,.docx"
            />
        </div>
    );
};

export default DoctorIdImage;
